module.exports = __webpack_public_path__ + "static/headerIcon-956de227aea10506a9cbead7848a97ec.svg";